import React from 'react';
import styles from '../Login/LoginNavbar.module.css';
import logo from '../../assets/images/logo.svg';
import {Link} from 'react-router-dom'

export default function LoginNavbar() {
    return (
        <div className={styles.navbar}>
            <Link to="/">
            <img src={logo} alt="logo" className={styles.logo} />
            </Link>
        </div>
    )
}
